import { EFinixBuyerCardStatus, schemes, zSchema } from "@zeal/common";

export const getBusinessCardsRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  businessCardID: schemes.uuid().optional(),
  status: zSchema.nativeEnum(EFinixBuyerCardStatus).optional(),
  testMode: zSchema.boolean().optional(),
});

export type TGetBusinessCardsRequestSchema = zSchema.infer<
  typeof getBusinessCardsRequestSchema
>;

export const getBusinessCardsResponseSchema = zSchema.array(
  zSchema.object({
    businessCardID: schemes.uuid(),
    companyID: schemes.uuid(),
    customerAccountID: schemes.uuid(),
    exp_date: zSchema.string(),
    last_four: zSchema.string(),
    card_company: zSchema.string(),
    auto_charge: zSchema.boolean(),
    status: zSchema.string(),
  })
);

export type TGetBusinessCardsResponseSchema = zSchema.infer<
  typeof getBusinessCardsResponseSchema
>;
